// Address → coordinates with the shop's Google Maps key (GOOGLE_MAPS_TOKEN),
// shared by the store addresses (About page) and the footer address link.
//
// Through the shop first (`viaShop` = the screen's mini-api GET /admin/geocode,
// like the legacy admin's server-side /geocode): from the admin's browser a key
// restricted to the shop's domain answers REQUEST_DENIED. When the shop cannot
// answer (older mini-api) or Google refuses the key there (e.g. one limited to
// browser use), the browser tries too — so more key set-ups work than with
// either route alone.
//
// Resolves to { lat, lng } (strings, 5 decimals: the columns are FLOAT and the
// legacy admin rounds the same) or { error } where error is 'no_key',
// 'not_found' or Google's own message/status.
const round5 = (n) => String(Math.round(Number(n) * 1e5) / 1e5);

export const lookupCoordinates = async (address, { viaShop, browserKey } = {}) => {
    let data = typeof viaShop === 'function' ? await viaShop(address) : null;
    if (data && data.status === 'OK') return { lat: round5(data.lat), lng: round5(data.lng) };
    const shopFinal = data && ['NO_KEY', 'ZERO_RESULTS', 'INVALID_REQUEST'].includes(data.status);
    if (!shopFinal && browserKey) {
        try {
            const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(address)}&key=${encodeURIComponent(browserKey)}`;
            const direct = await (await fetch(url)).json();
            if (direct.status === 'OK' && direct.results?.length) {
                const loc = direct.results[0].geometry.location;
                return { lat: round5(loc.lat), lng: round5(loc.lng) };
            }
            // keep the shop's own answer when there was one: it is the route
            // the key is meant for
            if (!data) data = direct;
        } catch { /* keep the shop's answer */ }
    }
    if (!data || data.status === 'NO_KEY') return { error: 'no_key' };
    if (data.status === 'ZERO_RESULTS') return { error: 'not_found' };
    return { error: data.error_message || data.status || 'failed' };
};
